import confetti from 'canvas-confetti';

const PALETTE = ['#22c55e', '#3b82f6', '#a855f7', '#f59e0b', '#ec4899', '#06b6d4'];

export function fireBurst(): void {
  confetti({
    particleCount: 120,
    spread: 80,
    startVelocity: 45,
    origin: { y: 0.4 },
    colors: PALETTE,
    scalar: 1,
    zIndex: 100,
  });
}

export function fireSideCannons(): void {
  const end = Date.now() + 800;
  const tick = () => {
    confetti({
      particleCount: 5,
      angle: 60,
      spread: 55,
      origin: { x: 0, y: 0.6 },
      colors: PALETTE,
      zIndex: 100,
    });
    confetti({
      particleCount: 5,
      angle: 120,
      spread: 55,
      origin: { x: 1, y: 0.6 },
      colors: PALETTE,
      zIndex: 100,
    });
    if (Date.now() < end) requestAnimationFrame(tick);
  };
  tick();
}

export function fireGoldRain(): void {
  confetti({
    particleCount: 150,
    spread: 160,
    startVelocity: 35,
    origin: { y: 0 },
    colors: ['#fbbf24', '#f59e0b', '#fcd34d', '#eab308'],
    shapes: ['circle', 'square'],
    scalar: 0.9,
    zIndex: 100,
  });
}
